<template>
  <div class="flex_box">
    <div class="current-active" />
    <div
      v-if="viewData.title"
      class="component-header"
    >
      <div
        class="component-title"
        :style="itemStyleMerge"
        :class="viewData.required ? 'required' : ''"
      >
        <div>{{ viewData.title }}</div>
        <div class="subtitle">
          {{ viewData.subtitle }}
        </div>
      </div>
    </div>
    <el-input
      v-model="viewData.defaultVal"
      :placeholder="viewData.placeholder"
    />
  </div>
</template>
<script>
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpTest',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      inputVal: null,
      viewData: {}
    }
  },
  watch: {
    viewData: {
      handler: function (val, oldVal) {
        console.log('SpInput-watch:viewData', val)
      },
      deep: true
    }
  },
  mounted () {
    console.log('spinput-viewData', this.viewData)
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/weappTmps/formTmps/index.scss';
.flex_box {
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
</style>
